import { render } from "./UserSettings.vue?vue&type=template&id=1c75add7"
const script = {}
script.render = render

export default script